import { getProtected, postProtected } from './utils';

/**
 * Get a list of all transactions for the authenticated player
 * @param {string} playerSessionID Session ID
 * @param {number} max The maximum number of transactions to retrieve
 * @param {number} offset Number of transactions to skip, ie if set to 30 then the first 30 transactions are skipped
 * @param {('Payment'|'Game'|'All')} transactionType The type of the transactions to retrieve
 */
export var getTransactions = function getTransactions(playerSessionID) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var transactionType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Payment';
  return getProtected('/transaction?max=' + max + '&offset=' + offset + '&transactionType=' + transactionType, playerSessionID);
};

/**
 * Get a detailed list of all "sub parts" in a transaction. The sub transactions will show exactly which wallets / bonuses contributed to the transaction.
 * @param {string} playerSessionID
 * @param {string} transactionId
 */
export var getTransaction = function getTransaction(playerSessionID, transactionId) {
  return getProtected('/transaction/' + transactionId, playerSessionID);
};

/**
 * Get all payments
 * @param {string} playerSessionID Session ID
 * @param {number} max The maximum number of transactions to retrieve
 * @param {number} offset Number of transactions to skip, ie if set to 30 then the first 30 transactions are skipped
 * @param {('withdraw'|'deposit'|'')} type The type of the transactions to retrieve
 */
export var getPayments = function getPayments(playerSessionID) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return getProtected('/transaction/payments?max=' + max + '&offset=' + offset + '&type=' + type, playerSessionID);
};

/**
 * Get all game play transactions
 * @param {string} playerSessionID Session ID
 * @param {number} max The maximum number of transactions to retrieve
 * @param {number} offset Number of transactions to skip, ie if set to 30 then the first 30 transactions are skipped
 */
export var getGamePlayTransactions = function getGamePlayTransactions(playerSessionID) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return getProtected('/transaction/gameplay?max=' + max + '&offset=' + offset, playerSessionID);
};

/**
 * Get all sportsbook transactions
 * @param {string} playerSessionID Session ID
 * @param {number} max The maximum number of transactions to retrieve
 * @param {number} offset Number of transactions to skip, ie if set to 30 then the first 30 transactions are skipped
 */
export var getSportsbookTransactions = function getSportsbookTransactions(playerSessionID) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return getProtected('/transaction/sportsbookbets?max=' + max + '&offset=' + offset, playerSessionID);
};

/**
 * Get all fantasy transactions
 * @param {string} playerSessionID Session ID
 * @param {number} max The maximum number of transactions to retrieve
 * @param {number} offset Number of transactions to skip, ie if set to 30 then the first 30 transactions are skipped
 */
export var getFantasyTransactions = function getFantasyTransactions(playerSessionID) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return getProtected('/transaction/fantasybets?max=' + max + '&offset=' + offset, playerSessionID);
};

/**
 *
 * @param {string} playerSessionID
 * @param {number} max
 * @param {number} offset
 * @returns
 */
export var getBingoTransactions = function getBingoTransactions(playerSessionID) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return getProtected('/transaction/bingogames?max=' + max + '&offset=' + offset, playerSessionID);
};

/**
 * Cancel a pending transaction, currently only valid for withdraws
 * @param {string} playerSessionID
 * @param {string} transactionId
 */
export var cancelTransaction = function cancelTransaction(playerSessionID, transactionId) {
  return postProtected('/transaction/cancel/' + transactionId, playerSessionID);
};

export default {
  getTransactions: getTransactions,
  getTransaction: getTransaction,
  getPayments: getPayments,
  getGamePlayTransactions: getGamePlayTransactions,
  getSportsbookTransactions: getSportsbookTransactions,
  getFantasyTransactions: getFantasyTransactions,
  getBingoTransactions: getBingoTransactions,
  cancelTransaction: cancelTransaction
};